import { defineStore } from "pinia";
import { FetchService } from "@/services/fetch.service";

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useMatrixStore = defineStore("parent/matrix", {
  state: () => {
    return {
      activeTab: "teachers",
      conflicts: null,
      smallestTimeInterval: 15
    };
  },

  actions: {
    async fetchConflicts(jsonBody) {
      const conflicts = await FetchService.fetchData("/schedule/conflicts", "post", jsonBody);
      return conflicts;
    }
  }
});
